<template>
  <label
    class="floating-label"
    :for="forAttr"
    :class="{ 'float-above': floatAbove }"
    :style="{
      '--custom-top': customTop,
    }"
  >
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: 'FloatingLabel',
  props: {
    forAttr: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      floatAbove: false,
      customTop: '50%',
    };
  },
  watch: {
    value(value) {
      if (value) {
        this.floatAbove = true;
      }
    },
  },
  mounted() {
    const label = this.$el;
    const inputElement = label.parentElement.querySelector(
      'input, select, textarea',
    );

    if (inputElement?.tagName === 'TEXTAREA') {
      this.customTop = '26px';
    }

    // float above if value is not empty
    if (inputElement.value !== '') {
      this.floatAbove = true;
    }

    inputElement.addEventListener('focus', () => {
      this.floatAbove = true;
    });

    inputElement.addEventListener('focusout', () => {
      if (inputElement.value === '') {
        this.floatAbove = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.floating-label {
  margin: 0;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  color: rgba(0, 0, 0, 0.8);
  font-size: $size-small;
  font-weight: $lb-normal;
  text-align: left;
  line-height: 1.15em;
  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: left top;
  transform: translateY(-50%);
  position: absolute;
  left: 16px;
  top: var(--custom-top);
  cursor: text;
  pointer-events: none;

  &.float-above {
    transform: translateY(-106%) scale(0.75);
  }
}
</style>
